/* eslint-disable no-shadow */
import React, { useEffect, useMemo } from 'react';
import { Box, Select } from 'grommet';
import { useDevicesContext } from '@/contexts/useDevices';
import { useTempDevicesContext } from '@/contexts/useTempDevices';

const DeviceSelector = ({
	deviceType,
	saveLocal,
	onChange,
}: {
	deviceType: string;
	saveLocal: boolean;
	onChange?: (deviceId: string) => void;
}) => {
	const { camera, mic, setDevice } = useTempDevicesContext();
	const { getDevices, availableCameras, availableMicrophones } =
		useDevicesContext();

	const isCamera = deviceType === 'video';

	useEffect(() => {
		getDevices();
	}, [getDevices]);

	const options = useMemo(() => {
		if (isCamera) {
			return availableCameras.map((device) => ({
				label: device.label,
				value: device.deviceId,
			}));
		}
		return availableMicrophones.map((device) => ({
			label: device.label,
			value: device.deviceId,
		}));
	}, [availableCameras, availableMicrophones, isCamera]);

	const handleChangeDevice = (deviceId: string) => {
		setDevice(deviceType, deviceId, saveLocal);
		if (onChange) {
			onChange(deviceId);
		}
	};

	return (
		<Box fill align="start" justify="start" pad="none">
			<Select
				name={isCamera ? 'camara-select' : 'microphone-select'}
				labelKey="label"
				valueKey={{ key: 'value', reduce: true }}
				value={isCamera ? camera?.deviceId : mic?.deviceId}
				options={options}
				onChange={({ value: nextValue }) => handleChangeDevice(nextValue)}
			/>
		</Box>
	);
};

export default DeviceSelector;
